import {
    Login,
    Demo,
    RecoverAccount,
    RecoverPassword,
    RecoverEmail,
    RecoverReset,
    RecoverSuccess,
    Register,
    RegisterSuccess,
    RegisterValidation,
    Form,
    FormLoading,
    FormValidation,
    FormSuccess,
    MasterPage,
    Terminos,
    LoginAdmin
} from '../Containers';
import Avanzadas from '../Containers/Avanzadas';

export default [
  {
    path: "/login",
    component: Login,
    breadcrumb: "Login",
    exact: true
  },
  {
    path: "/admin",
    component: LoginAdmin,
    breadcrumb: "Login",
    exact: true
  },
  {
    path: "/avanzadas",
    component: Avanzadas,
    breadcrumb: "Avanzadas"
  },
  {
    path: "/recover-account",
    component: RecoverAccount,
    breadcrumb: "Recover Account"
  },
  {
    path: "/recover-password",
    component: RecoverPassword,
    breadcrumb: "Recover Password"
  },
  {
    path: "/recover-email",
    component: RecoverEmail,
    breadcrumb: "Recover Email"
  },
  {
    path: "/recover-reset",
    component: RecoverReset,
    breadcrumb: "Recover Reset"
  },
  {
    path: "/recover-success",
    component: RecoverSuccess,
    breadcrumb: "Recover Success"
  },
  {
    path: "/register",
    component: Register,
    breadcrumb: "Register"
  },
  {
    path: "/register-success",
    component: RegisterSuccess,
    breadcrumb: "Register Success"
  },
  {
    path: "/register-validation",
    component: RegisterValidation,
    breadcrumb: "Register Validation"
  },
  {
    path: "/form",
    component: Form,
    breadcrumb: "Alta Formulario"
  },
  {
    path: "/terminos",
    component: Terminos,
    breadcrumb: "Terminos y condiciones"
  },
  {
    path: "/form-loading",
    component: FormLoading,
    breadcrumb: "Alta Formulario"
  },
  {
    path: "/form-validated",
    component: FormValidation,
    breadcrumb: "Alta Formulario"
  },
  {
    path: "/form-success",
    component: FormSuccess,
    breadcrumb: "Alta Formulario"
  },
  {
    path: "/demo",
    component: Demo,
    breadcrumb: "Demo"
  },
  {
    path: "/master-page",
    component: MasterPage,
    breadcrumb: "Master Page"
  },
];
